import { useEffect } from 'react';
import { LoginManager } from './loginManager';

export const useAccessToken = (loginManager: LoginManager, onProcessToken: (token: string | null) => Promise<void>) => {
  useEffect(() => {
    // Initiate ACL request flow
    loginManager.getTokenAsync().then(onProcessToken);

    const accessTokenSub = loginManager.accessTokenObservable().subscribe({
      next: token => {
        // Triggered when the observable pushes a new token - typically when it is refreshed.
        // The observed behavior is that this observeable will only update so long as the webpage is not in a background tab.
        onProcessToken(token?.id_token ?? null);
      },
    });

    return () => {
      accessTokenSub?.unsubscribe();
    };
  }, [loginManager, onProcessToken]);
};
